export enum FontPickerType {
  Custom = 'custom',
  Sentence = 'sentence',
  Paragraph = 'paragraph'
};
